import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPage } from "../../constants/import_modal_page";
import { useImportSkillsModalContext } from "../../contexts/import_skills_modal_context";
import css from "./import_modal_footer.module.scss";

type ImportModalFooterProps = {
  handleClose?: VoidFunction;
};

export const ImportModalFooter = ({ handleClose }: ImportModalFooterProps): JSX.Element => {
  const { t } = useTranslation(["skillsManagement", "translation"]);
  const { currentPage, setCurrentPage } = useImportSkillsModalContext();

  return (
    <footer className={css.footer}>
      <Button kind="secondary" onClick={handleClose}>
        {t("translation:cancel")}
      </Button>
      {currentPage === ImportModalPage.ImportSuccess && (
        <span className={css.rightButtons}>
          <Button
            text={t("skillsManagement:header.modals.import.startNewImport")}
            kind="secondary"
            onClick={() => setCurrentPage(ImportModalPage.Upload)}
          />

          <Button text={t("translation:close")} kind="primary" onClick={handleClose} />
        </span>
      )}
    </footer>
  );
};
